<template>
  <div class="HomeContent ">
    <video class="video1" autoplay loop muted playsinline>
      <source  :src="video_src1" type="video/mp4" key="1">
    </video>
    <div class="bg_filter v1_filter"></div>

    <div class="splashTitel" v-if="isTitle">
      <transition appear name="pageTitle">
      <svg version="1.1" id="レイヤー_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
         y="0px" viewBox="0 0 1280 1024" style="enable-background:new 0 0 1280 1024;" xml:space="preserve">

        <g>
          <path class="st0" d="M447,779c-16,0-29-13-29-29V312c0-16,13-29,29-29h438c16,0,29,13,29,29v438c0,16-13,29-29,29H447z"/>
          <path d="M885,285c14.9,0,27,12.1,27,27v438c0,14.9-12.1,27-27,27H447c-14.9,0-27-12.1-27-27V312c0-14.9,12.1-27,27-27H885 M885,281
            H447c-17.1,0-31,13.9-31,31v438c0,17.1,13.9,31,31,31h438c17.1,0,31-13.9,31-31V312C916,294.9,902.1,281,885,281L885,281z"/>
        </g>
        <g>
          <path d="M570.1,312.4v237.2h-61.7V450H490v99.6h-61.7V312.4H490v84.8h18.5v-84.8H570.1z"/>
        </g>
        <g>
          <path class="st1" d="M595.4,378.5h46.1c29.8,0,49.9,1.4,60.4,4.1c10.5,2.7,18.5,7.2,24,13.5c5.5,6.3,8.9,13.2,10.3,20.9
            c1.4,7.7,2.1,22.7,2.1,45.2v83.1c0,21.3-1,35.5-3,42.7c-2,7.2-5.5,12.8-10.5,16.8c-5,4.1-11.1,6.9-18.5,8.5s-18.4,2.4-33.1,2.4
            h-77.8V378.5z M657.1,419.1v156c8.9,0,14.4-1.8,16.4-5.3c2.1-3.6,3.1-13.3,3.1-29.1v-92.1c0-10.7-0.3-17.6-1-20.7
            c-0.7-3-2.2-5.2-4.7-6.7C668.4,419.8,663.8,419.1,657.1,419.1z"/>
        </g>
        <g>
          <path class="st2" d="M766.7,444.7h43.7c29.1,0,48.8,1.1,59.1,3.4c10.3,2.2,18.7,8,25.2,17.2c6.5,9.2,9.7,24,9.7,44.2
            c0,18.5-2.3,30.9-6.9,37.2c-4.6,6.3-13.6,10.2-27.1,11.4c12.2,3,20.4,7.1,24.6,12.2c4.2,5.1,6.8,9.7,7.8,14s1.5,15.9,1.5,35.1v62.5
            h-57.3V603c0-12.7-1-20.6-3-23.6c-2-3-7.3-4.5-15.7-4.5v106.9h-61.7V444.7z M828.4,485.2V538c6.9,0,11.8-1,14.6-2.9
            s4.2-8.1,4.2-18.5v-13c0-7.5-1.3-12.5-4-14.8C840.4,486.4,835.5,485.2,828.4,485.2z"/>
        </g>
        <g>
          <rect x="342" y="1159" width="583" height="129"/>
        </g>
        <g>
          <path d="M416,690v60c0,17.1,13.9,31,31,31h438c17.1,0,31-13.9,31-31v-60H416z"/>
        </g>
      </svg>
      </transition>
      <transition appear name="pageTitle">
        <div class="sp_title">2018 TOURdeHDR+ COLLECTION </div>
      </transition>
      <transition appear name="pageTitle">
        <p>  STAGE 1 - 11 </p>
      </transition>

    </div>

    <!-- <div class="mainContent" v-if="!isTitle"> -->
    <div v-if="!isTitle">
      <div class="mainContent" >
      <div class="centerLine"></div>
      <section class="project">
       
        <video class="video2" autoplay loop muted playsinline>
          <source  :src="video_src2" type="video/mp4" key="2">
        </video>
        <div class="bg_filter v2_filter"></div>
         <router-link to="/project">
          <div class="homeTitle">
            <p>TOURdeHDR+</p>
            <h1>STAGE</h1>
          </div>
          <div class="homeLink">
            <div class="linkText textDate">
              <p>
                It is the main picture of the stage
              </p>
            </div>
            <div class="linkButton buttonDate">
              <p>
                <router-link to="/project">
                  STAGE
                </router-link>
              </p>
            </div>
          </div>
        </router-link>
      </section>

      <section class="collection">
        <router-link to="/awards">
        <video class="video3" autoplay loop muted playsinline>
          <source  :src="video_src3" type="video/mp4" key="3">
        </video>
        <div class="bg_filter v3_filter"></div>

        <div class="homeTitle">
           <p>TOURdeHDR+</p>
          <h1>AWARDS</h1>
        </div>
        <div class="homeLink">
          
          <div class="linkText textSpots">
            <p>
                I picked up a good picture of the year
            </p>
          </div>
          <div class="linkButton buttonSpots">
            <p>
              <!-- <router-link to="/collection"> -->
              <router-link to="/awards">
               AWARDS
              </router-link>
            </p>
          </div>
        </div>
        </router-link>
      </section>
    </div>
</div>


  </div>
</template>

<script>
export default {
  name: 'HomeContent',
  props: {
    msg: String
  },
  data() {
    return {
      video_src1: require("../assets/img/Indian Tea.mp4"),
      video_src2: require("../assets/img/Painting960.mp4"), 
      video_src3: require("../assets/img/Night-Traffic.mp4"),
      isTitle: true, 
    }
  },
  mounted: function () {
    // window.addEventListener('scroll', this.handleScroll);
    // this.init_load = true;
    this.isTitle = true;
    // this.getUnits()
    // this.getPageUnits()
    this.titleLoad()
  },
  methods: {
    titleLoad: function() {
      setTimeout(() => {
        this.isTitle = false;
      }, 2500);
    },
  }
}
</script>
<style scoped lang="scss">
//  @import "../assets/scss/page/homeComponent.scss";
.HomeContent{
  width: 100%;
  height: 100%;
  // text-align: center;
  // padding: auto 0;
}
.splashTitel{
  width: 100%;
  height: 100%;
  // padding: 1rem;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.splashTitel .sp_title{
  font-size: 1rem;
  font-weight: 500;
  color: #fff;
   @media (min-width: 1024px) {
      font-size: 2rem;
      font-weight: 400;
  }
  
}
.mainContent{
  width: 100%;
  height: 100%;
  // padding: 1rem;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  @media (min-width: 1024px) {
    flex-direction: row;
    justify-content: space-around;
  }
}
.centerLine{
  display: none;
  position: absolute;
  top: 20%;
  left: 50%;
  transform: rotate(90deg);
  transform-origin: top left;
  border-top: 1px solid rgba(250,250,250,1);
  width:60vh;
  height: 1px;
  @media (min-width: 1024px) {
   display: block;
  }
}
.project, .collection{
  position:relative;
  overflow: hidden;
  width: 100%;
  // padding: 1rem;
  cursor: pointer;
  height: 50vh;
  // height: calc((100vh - 6rem) /2);
  @media (min-width: 1024px) {
    width: 50%;
    // height: calc(100vh - 6rem);
    height: 100vh;
  }
}

.project{
  @media (min-width: 1024px) {
    &:hover .buttonDate{
      opacity: 1;
      transition: .5s all;
      transform: translateY(-4rem);
    }
    &:hover .textDate{
      transition: .5s .1s all;
      transform: translateY(-2.5rem);
    }
  }
}
.collection{
   @media (min-width: 1024px) {
      &:hover .buttonSpots{
        opacity: 1;
        transition: .5s all;
        transform: translateY(-4rem);
      }
      &:hover .textSpots{
        transition: .5s .1s all;
        transform: translateY(-2.5rem);
      }
  }
}

.homeTitle{
  position:absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50% , -50%);
}
.homeLink{
  width: 100%;
  position:absolute;
  bottom: 0;
  left: 50%;
  transform: translatex(-50%);
}

.linkText{
  width: 100%;
  margin: 2rem 0;
  text-align: center;
  transition: .5s all;
}
.linkButton{
  border: 1px solid #fff;
  width: 10rem;
  height: 2rem;
  margin: 0  auto;
  text-align: center;
  opacity: 0;
  transition: .5s all;
  &:hover{
    background-color: #fff;
    a{
      color: #212121;
    }
  }
  display: none;
  @media (min-width: 1024px){
    display: block;
  }
  
}
video.video1 {
  position: fixed;
  top: 0;
  left: 0;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: -1;
  display: none;
  @media (min-width: 1024px) {
    display: block;
  }
}
.v1_filter{
  display: none;
  @media (min-width: 1024px) {
    display: block;
  }
}
video.video2, video.video3 {
  position: absolute;
  top: -30%;
  left: -30%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: -1;
  display: block;
  // background-size: content;
  @media (min-width: 1024px) {
    display: none;
  }
}
.v2_filter, .v3_filter{
  display: block;
  @media (min-width: 1024px) {
    display: none;
  }
}


.bg_filter{
    background-color: rgba(0,0,0,.5);
    position: fixed;
    top: 0;
    left: 0;
    min-width: 100%;
    min-height: 100%;
    width: auto;
    height: auto;
    z-index: -1;
}
svg{
  width: 300px;
  height: 300px;
}
	.st0{fill:#FFFFFF;}
	.st1{fill:#333333;}
	.st2{fill:#666666;}



</style>
